<template>
  Deals
</template>

<script>
export default {
  name: 'Deals'
}
</script>
